import { render, staticRenderFns } from "./CuadraturaSubTab_new.vue?vue&type=template&id=0a4732fa&"
import script from "./CuadraturaSubTab_new.vue?vue&type=script&lang=js&"
export * from "./CuadraturaSubTab_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports